import React from "react";
import "./Vission.css";
import image1 from "../Assests/mission.png";
import image2 from "../Assests/vision.png"; // Replace with actual image paths
// import image2 from "../Assests/img9.jpg";

const Vission = () => {
  return (
    <div className="vission-container">
      {/* About Section */}
      <div className="about-section">
        <div className="text-content">
          {/* <div className="vission-box1"> */}

          {/* <h1>Main headline for your about section</h1> */}
          <p>
            At HospiPharma, our mission is to provide innovative and
            high-quality pharmaceutical solutions that meet diverse medical
            needs. We are committed to ensuring accessible, affordable, and
            reliable healthcare for all.
          </p>
          <div className="mission-divider"></div>
          <h3>MISSION!</h3>
        </div>
        <div className="image-group">
          <img src={image1} alt="Fabric Rolls" className="main-image" />
          {/* <img src={image2} alt="Designer Working" className="overlay-image" /> */}
        </div>
        {/* </div> */}
      </div>

      {/* Second Section with Image and Text */}
      <div className="about-section">
        <img src={image2} alt="Decorative Setup" className="main-image-small" />
        <div className="text-content">
          <p className="vission-pragh">
            HospiPharma envisions becoming a pioneer in the pharmaceutical
            industry by delivering innovative, high-quality, and accessible
            healthcare solutions. We strive to advance patient care through
            science, technology.
          </p>
          <div className="vission-divider"></div>
          <h3>VISION!</h3>
          {/* <button className="read-more-btn">Read More</button> */}
        </div>
      </div>

      {/* Quote Section */}
      <div className="quote-section">
        <p className="quote-heading">WORDS ON THE STREET</p>
        <p className="quote-text">
        At HospiPharma, our values are built on quality, innovation, accessibility, and a commitment to enhancing healthcare for all.
        </p>
        <p className="quote-author">
          <span style={{ color: "#ff5500" }}>—— </span>OUR VALUES!
        </p>
      </div>
    </div>
  );
};

export default Vission;
